var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import * as moment from 'moment';
import { feathersServices } from 'src/feathers';
import Avatar from 'antd/lib/avatar';
import 'antd/lib/avatar/style/index.css';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import Icon from 'antd/lib/icon';
import List from 'antd/lib/list';
import 'antd/lib/list/style/index.css';
import 'antd/lib/spin/style/index.css';
import 'antd/lib/pagination/style/index.css';
import 'antd/lib/grid/style/index.css';
import Spinner from '@atlaskit/spinner';
import PageBasic from 'src/pages/templates/PageBasic';
var selfStyles = require('./styles.scss');
var crimpIcon = require('src/assets/logo/crimp-icon@0,15x.png');
var PageEventNotFound = (function (_super) {
    __extends(PageEventNotFound, _super);
    function PageEventNotFound(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: true,
        };
        return _this;
    }
    PageEventNotFound.prototype.componentDidMount = function () {
        var _this = this;
        this.handleFindEvents()
            .then(function (res) {
            _this.setState({
                isFetching: false,
                events: res.value.data.sort(function (a, b) { return moment(a.dateStart).isAfter(moment(b.dateEnd)) ? -1 : 1; }),
            });
        })
            .catch(function () {
            _this.setState({
                isFetching: false,
            });
        });
    };
    PageEventNotFound.prototype.handleFindEvents = function () {
        return this.props.dispatch(feathersServices.events.find({
            query: {
                isDeleted: false,
                paymentTier: { $gte: 1 },
                $limit: 5,
                $sort: {
                    dateStart: -1,
                },
            },
        }));
    };
    PageEventNotFound.prototype.render = function () {
        var events = this.state.events;
        return (React.createElement(PageBasic, null,
            React.createElement("div", { className: selfStyles.wrapper },
                React.createElement(Card, { className: selfStyles.card, hoverable: false },
                    React.createElement("div", { className: selfStyles.brand },
                        React.createElement("img", { src: crimpIcon })),
                    this.props.errorMessage && React.createElement("div", { className: selfStyles.message }, this.props.errorMessage),
                    React.createElement(Divider, null),
                    this.state.isFetching && React.createElement("div", { className: selfStyles.message },
                        React.createElement(Spinner, { size: 'large' })),
                    events && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: selfStyles.message }, "Were you looking one of these?"),
                        React.createElement("div", { className: selfStyles.list },
                            React.createElement(List, { dataSource: events, renderItem: function (event) { return (React.createElement("a", { href: "//" + event.subdomain + "." + process.env.CLIENT_HOSTNAME },
                                    React.createElement("div", { className: selfStyles.listAvatar },
                                        React.createElement(Avatar, { shape: 'square', size: 'large', src: event.logoUrl || event.logoIdenticon })),
                                    React.createElement("div", { className: selfStyles.listInfo },
                                        React.createElement("span", { className: selfStyles.listName }, event.name),
                                        React.createElement("span", { className: selfStyles.listAddress }, event.subdomain + "." + process.env.CLIENT_HOSTNAME)),
                                    React.createElement("div", { className: selfStyles.listIcon },
                                        React.createElement(Icon, { type: 'right' })))); } }))))))));
    };
    return PageEventNotFound;
}(React.Component));
export default connect()(PageEventNotFound);



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageEventNotFound/index.tsx
// module id = 250
// module chunks = 0